<template functional>
  <div class="appt-cod flex-col" :class="props.item.appt_cod">
    <div>{{ props.item.cod_fmt }}</div>
    <div class="text-2xs" v-if="props.item.rail_cutoff_time">
      {{ props.item.rail_cutoff_time }}
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-cod",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
